import React from 'react';
import classnames from 'classnames';
import { timeAgoStepped } from 'helpers/_date-helpers';
import { InfoTooltip } from 'lib';
import SectionValue, { formatInitials } from './SectionValue';
import { CHANGE_TYPE } from './constants';

const RecentChangeCard = ({ change, classes }) => {
  const type = CHANGE_TYPE[change.changeType];

  return (
    <div className={classes.card}>
      <div className={classes.cardTopRow}>
        <span className={classes.sectionTitle}>{change.sectionLabel}:</span>
        <span className={classes.time}>{timeAgoStepped(change.notifiedAt)}</span>
      </div>
      <div className={classes.valueRow}>
        <div className={classes.value}>
          <SectionValue change={change} classes={classes} />
        </div>
        {type && (
          <div className={classes.typeRow}>
            <span className={classnames(classes.typeLabel, classes[type.className])}>{type.label}</span>
            {change.changedBy && (
              <InfoTooltip
                content={`${type.label} by ${formatInitials(change.changedBy.fullName) || change.changedBy.username}`}
                iconSize="small"
                placement="left"
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentChangeCard;
